import React from 'react';
import { Sparkles, BookOpen, HandHeart, Calendar } from 'lucide-react';
import { ProductCard } from './ProductCard';
export function MagazinProducts() {
  const products = [{
    href: 'https://academiadeabundenta.ro/colectie',
    image: 'https://cdn.magicpatterns.com/uploads/fLQyV4DXMpF3W56aeVAZJ1/academia_abundentei_program_complet.png',
    badgeText: 'Program Complet',
    badgeIcon: Sparkles,
    category: 'Recomandat',
    title: 'Academia de Abundență',
    subtitle: 'Colecția completă de 6 cursuri',
    oldPrice: '4.200 lei',
    newPrice: '1.200 lei',
    description: 'Cele 6 cursuri online + 24 întâlniri săptămânale de grup, meditații și acces pe viață. Procesul complet pentru o viață cu sens, liniște și abundență.',
    ctaText: 'Vreau Academia de Abundență',
    recommended: true
  }, {
    href: 'https://academiadeabundenta.ro/cursmagnet',
    image: 'https://cdn.magicpatterns.com/uploads/c1JbRALxMUfWKQRES96Eqh/magnet_pentru_bani.png',
    badgeText: 'Curs Online',
    badgeIcon: BookOpen,
    category: 'Începători',
    title: 'Magnet pentru Bani',
    subtitle: 'Schimbă-ți relația cu banii',
    oldPrice: '900 lei',
    newPrice: '500 lei',
    description: 'Identifici credințele care te blochează financiar și înveți cum să devii un magnet care atrage prosperitatea, natural și fără stres.',
    ctaText: 'Vreau Cursul Magnet pentru Bani'
  }, {
    href: 'https://academiadeabundenta.ro/cursabc',
    image: 'https://cdn.magicpatterns.com/uploads/bUax4yscNTFMxnmnw1UX3N/abc_prosperitatii.png',
    badgeText: 'Curs Online',
    badgeIcon: BookOpen,
    category: 'Începători',
    title: 'ABC-ul Prosperității',
    subtitle: 'Harta comorilor către viața ta',
    oldPrice: '900 lei',
    newPrice: '500 lei',
    description: 'Descoperi sensul adevăratei bogății, eliberezi gândurile limitative și îți creezi propria hartă pentru o viață prosperă pe toate planurile.',
    ctaText: 'Vreau Cursul ABC-ul Prosperității'
  }, {
    href: 'https://academiadeabundenta.ro/curstraieste',
    image: 'https://cdn.magicpatterns.com/uploads/6oCfa3wyhj25YG64HzZabs/traieste_in_prezent.png',
    badgeText: 'Curs Online',
    badgeIcon: BookOpen,
    category: 'Intermediari',
    title: 'Trăiește în Prezent',
    subtitle: 'Și împlinește-ți visul',
    oldPrice: '900 lei',
    newPrice: '500 lei',
    description: 'Cele 7 legi spirituale ale succesului, conștiința bogăției și practici concrete pentru a trăi conștient și a-ți transforma visurile în realitate.',
    ctaText: 'Vreau Cursul Trăiește în Prezent'
  }, {
    href: 'https://academiadeabundenta.ro/cursdeschide',
    image: 'https://cdn.magicpatterns.com/uploads/gNcUuH95NLxTCM4phVhmkX/deschide_ti_larg_bratele.png',
    badgeText: 'Curs Online',
    badgeIcon: BookOpen,
    category: 'Intermediari',
    title: 'Deschide-ți Larg Brațele',
    subtitle: 'Către abundență',
    oldPrice: '900 lei',
    newPrice: '500 lei',
    description: 'Meditații care îți aduc pacea minții și unelte practice pentru abundență pe toate planurile vieții. Include propoziția win-win.',
    ctaText: 'Vreau Cursul Deschide-ți Larg Brațele'
  }, {
    href: 'https://academiadeabundenta.ro/cursarta',
    image: 'https://cdn.magicpatterns.com/uploads/iSesnZuf4dH9NUhLuhZr2H/arta_de_a_trai_fara_stres.png',
    badgeText: 'Curs Online',
    badgeIcon: BookOpen,
    category: 'Intermediari',
    title: 'Arta de a Trăi Fără Stres',
    subtitle: 'Liniște în fiecare zi',
    oldPrice: '900 lei',
    newPrice: '500 lei',
    description: 'Tehnici de respirație, calmare a minții și obiceiuri zilnice care îți susțin liniștea și energia. Pentru o viață trăită cu echilibru.',
    ctaText: 'Vreau Cursul Arta de a Trăi Fără Stres'
  }, {
    href: 'https://academiadeabundenta.ro/cursiubire',
    image: 'https://cdn.magicpatterns.com/uploads/3zFADQGzq1UfnWNKdseBTS/abundenta_iubirii.png',
    badgeText: 'Curs Online',
    badgeIcon: BookOpen,
    category: 'Intermediari',
    title: 'Abundența Iubirii',
    subtitle: 'Învață să te iubești pe tine',
    oldPrice: '900 lei',
    newPrice: '500 lei',
    description: 'Exercițiul oglinzii, cercul iubirii, practici de iertare și meditații ghidate pentru creșterea vibrației și reconectarea la iubire autentică.',
    ctaText: 'Vreau Cursul Abundența Iubirii'
  }, {
    href: 'https://academiadeabundenta.ro/oferta1la1',
    image: 'https://cdn.magicpatterns.com/uploads/55mZesWmwFs3sFS6d7RVtE/sesiuni_theta_healing.png',
    badgeText: 'Terapie 1 la 1',
    badgeIcon: HandHeart,
    category: 'Avansați',
    title: 'Sesiuni Theta Healing®',
    subtitle: 'Lucru personal 1 la 1 cu Adrian',
    oldPrice: '500 lei',
    newPrice: 'de la 300 lei',
    description: 'O ședință individuală sau pachet de 6 ședințe Theta Healing® pentru lucru profund cu blocajele subconștiente. Atenție personală, traseu personalizat.',
    ctaText: 'Vreau Terapie 1 la 1'
  }, {
    href: 'https://academiadeabundenta.ro/workshop',
    image: 'https://cdn.magicpatterns.com/uploads/5bjNTMoBRUecd4aMFjD6ey/elibereaza_te_de_blocaje.png',
    badgeText: 'Workshop Online Gratuit',
    badgeIcon: Calendar,
    category: 'Toate nivelurile',
    title: 'Eliberează-te de Blocaje',
    subtitle: 'Workshop live de 90 de minute',
    newPrice: 'Gratuit',
    description: 'Un workshop online practic în care descoperi ce te blochează, primești o tehnică concretă și participi la o meditație ghidată. Primul pas spre o viață abundentă.',
    ctaText: 'Vreau să Particip la Workshop'
  }];
  return <section className="py-20 lg:py-28 bg-brand-cream relative -mt-12" data-id="element-1588">
      <div className="max-w-7xl mx-auto px-6" data-id="element-1589">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1590">
          {products.map((product, index) => <ProductCard key={index} {...product} index={index} data-id="element-1591" />)}
        </div>
      </div>
    </section>;
}